import { SearchDateParams } from "interface/admin/interface.dashboard";
import axiosInstance from "plugin/axios";

export const fetchLoadUserTotalCount = async (params: SearchDateParams) => {
  try {
    const response = await axiosInstance.get(
      `/admin/dashboard/user-total-count`,
      { params: params }
    );
    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchLoadSimpleTestCount = async (params: SearchDateParams) => {
  try {
    const response = await axiosInstance.get(
      `/admin/dashboard/simple-test-count`,
      { params: params }
    );
    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchLoadSimpleMeasureCount = async (params: SearchDateParams) => {
  try {
    const response = await axiosInstance.get(
      `/admin/dashboard/simple-measure-count`,
      { params: params }
    );
    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchLoadReviewCount = async (params: SearchDateParams) => {
  try {
    const response = await axiosInstance.get(`/admin/dashboard/review-count`, {
      params: params,
    });
    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchLoadDeepTestCount = async (params: SearchDateParams) => {
  try {
    const response = await axiosInstance.get(
      `/admin/dashboard/deep-test-count`,
      { params: params }
    );
    return response.data;
  } catch (error) {
    throw new Error();
  }
};

export const fetchLoadActiveUserCount = async (params: SearchDateParams) => {
  try {
    const response = await axiosInstance.get(
      `/admin/dashboard/active-user-count`,
      { params: params }
    );
    return response.data;
  } catch (error) {
    throw new Error();
  }
};
